import { useEffect, useState } from "react";
import { usePuzzelExtendedStateInformation } from "features/Header/PuzzelTelephone/provider/contexts/ListenForCallStatusContext";
import CallerNumberInfo from "features/Header/PuzzelTelephone/components/CallerNumberInfo";
import {
  CallIconStyled,
  CallStatusStyled,
} from "features/Header/PuzzelTelephone/PuzzelStyle";
import {
  assembleFullName,
  NO_COUNTRY_CODE_PREFIX,
  removePhoneNumberPrefixes,
} from "features/Header/PuzzelTelephone/utils";
import {
  IqSessionRequestType,
  Status,
} from "features/Header/PuzzelTelephone/components/types";
import { usePuzzelAuthenticationContext } from "features/Header/PuzzelTelephone/provider/contexts/PuzzelAuthenticationContext";
import { useUserValidationState } from "features/Header/PuzzelTelephone/provider/contexts/UserValidationContext";
import { performPuzzelCatalogSearch } from "api/puzzel/puzzel";

const CallAllocated = () => {
  const { iqSessionStateRequests }: any = usePuzzelExtendedStateInformation();
  const puzzelContext = usePuzzelAuthenticationContext();
  const { phoneNumberPrefix, functionalNumberPrefix } = puzzelContext;
  const puzzelUserId = useUserValidationState().userId;
  const [callerName, setCallerName] = useState("");
  const [callerNumber, setCallerNumber] = useState<string>();

  const resetCaller = () => {
    setCallerName("");
    setCallerNumber("");
  };

  useEffect(() => {
    if (callerNumber) {
      void performPuzzelCatalogSearch({
        searchString: callerNumber,
        userId: puzzelUserId,
      }).then((response) => {
        if (response.data?.result.length > 0) {
          const fullName = assembleFullName(response.data?.result);
          setCallerName(fullName);
        }
      });
    }
  }, [callerNumber]);

  useEffect(() => {
    if (iqSessionStateRequests?.length > 0) {
      const incomingPhoneNumber = removePhoneNumberPrefixes(
        iqSessionStateRequests[0].remoteAddress,
        [phoneNumberPrefix, NO_COUNTRY_CODE_PREFIX, functionalNumberPrefix],
      );
      setCallerNumber(incomingPhoneNumber);
    } else {
      resetCaller();
    }
  }, [iqSessionStateRequests, phoneNumberPrefix, functionalNumberPrefix]);

  if (callerNumber) {
    return iqSessionStateRequests
      .filter((req: IqSessionRequestType) => req.status === Status.Allocated)
      .map((req: IqSessionRequestType) => (
        <CallStatusStyled $showBigAnimation key={req.id}>
          <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
            <CallIconStyled />
            <CallerNumberInfo
              status={req.status}
              remoteAddress={`${callerName} ${callerNumber}`}
            />
          </div>
        </CallStatusStyled>
      ));
  }
  return null;
};

export default CallAllocated;
